/**
 * Is this island the student's yet?
 *
 * One question, asked from the three adventure routes that hang off a kingdom —
 * the kingdom page, its quest line and its boss — so that "sealed" means the
 * same thing on all of them. `worldState` is the only source; nothing here
 * reads XP, level or gold, and nothing here is ever asked about a lesson.
 *
 * **A seal withholds the island, never the mathematics**
 * (`packages/world/src/types.ts`). A sealed quest page and a sealed boss page
 * send the student to the kingdom's own page, which is the gate rather than the
 * island: it states the seal in mathematics and hands over every concept that
 * breaks it, each of which opens its lesson and its practice as it always did.
 * `canOpenLesson()` still returns true unconditionally.
 *
 * Because `openDownwards` leaves `sealed` upward closed — an open kingdom opens
 * every kingdom below it, so a sealed one can have nothing open above it —
 * asking this one question about one kingdom is also the whole of "and nothing
 * more advanced than it either".
 */

import { KINGDOMS } from '@yuan-math/content';
import type { LearnerProfile } from '@yuan-math/learning';
import { worldState } from '@yuan-math/world';
import { registry } from '../state/LearnerContext.tsx';

export function kingdomSealed(profile: LearnerProfile | null, kingdomId: string | undefined, now: number): boolean {
  if (!kingdomId) return false;
  return (
    worldState(KINGDOMS, registry.graph, profile?.concepts ?? {}, profile?.rpg?.clearedBossIds ?? [], now).find(
      (state) => state.kingdomId === kingdomId,
    )?.status === 'sealed'
  );
}
